"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreeFinancial = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var agreement_1 = require("../../model/agreement");
var service_1 = require("../../../library/base/service");
var AgreeFinancial = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AgreeFinancial, _super);
    function AgreeFinancial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户同意高端理财协议接口';
        _this.code = '101108';
        _this.desc = '用户同意高端理财协议接口';
        _this.requestParams = new agreement_1.AgreeFinancialRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AgreeFinancial;
}(service_1.BaseService));
exports.AgreeFinancial = AgreeFinancial;
//# sourceMappingURL=agreeFinancial.js.map